'use client';

import { useEffect } from 'react';
import { CheckCircle, X, Trash2 } from 'lucide-react';

export default function Toast({ message, type = 'success', onClose, duration = 3000 }) {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className="fixed top-20 right-4 z-[9999] animate-slide-in-right">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border ${
        type === 'success'
          ? 'bg-white border-green-200'
          : 'bg-white border-red-200'
      } min-w-[300px] max-w-md`}>
        {type === 'success' ? (
          <CheckCircle className="text-green-600 flex-shrink-0" size={20} />
        ) : (
          <Trash2 className="text-red-600 flex-shrink-0" size={20} />
        )}
        <p className="text-sm font-medium text-gray-900 flex-1">{message}</p>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
